export default "__VITE_ASSET__B_r0YxJi__"